var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronSmallLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 8,
  fill: "none",
  viewBox: "0 0 8 8"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  fillRule: "evenodd",
  d: "M6.2.146a.5.5 0 0 1 0 .708L3.055 4l3.147 3.146a.5.5 0 0 1-.708.708L1.64 4 5.493.146a.5.5 0 0 1 .708 0",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h8v8H0z"
})))));
export { SvgChevronSmallLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNzQ0Xzk0NDMpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjIwMDU0IDAuMTQ2NDM5QzYuMzk1OCAwLjM0MTcwMSA2LjM5NTggMC42NTgyODQgNi4yMDA1NCAwLjg1MzU0NkwzLjA1NDA5IDMuOTk5OTlMNi4yMDA1NCA3LjE0NjQ0QzYuMzk1OCA3LjM0MTcgNi4zOTU4IDcuNjU4MjggNi4yMDA1NCA3Ljg1MzU1QzYuMDA1MjggOC4wNDg4MSA1LjY4ODY5IDguMDQ4ODEgNS40OTM0MyA3Ljg1MzU1TDEuNjM5ODggMy45OTk5OUw1LjQ5MzQzIDAuMTQ2NDM5QzUuNjg4NjkgLTAuMDQ4ODIzIDYuMDA1MjggLTAuMDQ4ODIzIDYuMjAwNTQgMC4xNDY0MzlaIiBmaWxsPSIjMUMxQzFBIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNzQ0Xzk0NDMiPgo8cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSI4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";